import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { INotificationType } from 'libs/domain';
import { gateway } from 'libs/generated-grpc-web';
import { isBadgeNotification, isChallengeResponseNotification, isPointsNotification } from 'libs/shared';

@Component({
  selector: 'mg-notification',
  templateUrl: './MgNotification.element.html',
  styleUrls: ['./MgNotification.element.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MgNotificationElement {
  @Input()
  notification?: gateway.notification_pb.Notification.AsObject;

  isBasicNotification() {
    return (
      this.notification &&
      this.notification.displayBasic &&
      !this.isPointsNotification() &&
      !this.isEventInviteNotification() &&
      !this.isBadgeNotification() &&
      !this.isChallengeInviteNotification() &&
      !this.isChallengeResponseNotification()
    );
  }

  isEventNotification() {
    return this.notification && this.notification.displayEvent;
  }

  isPersonNotification() {
    return this.notification && this.notification.displayPerson;
  }

  isPersonTitleNotification() {
    return this.notification && this.notification.displayPersonTitle;
  }

  isPointsNotification() {
    return (
      this.notification &&
      isPointsNotification(this.notification.notificationType) &&
      !this.isEventInviteNotification() &&
      !this.isChallengeInviteNotification()
    );
  }

  isEventInviteNotification() {
    return this.notification && this.notification.notificationType === INotificationType.EVENT_INVITE;
  }

  isBadgeNotification() {
    return this.notification && isBadgeNotification(this.notification.notificationType);
  }

  isChallengeInviteNotification() {
    return this.notification && this.notification.notificationType === INotificationType.CHALLENGE_INVITE;
  }

  isChallengeResponseNotification() {
    return this.notification && isChallengeResponseNotification(this.notification.notificationType);
  }
}
